import React from "react";

/**
 * Shared layout for legal pages (Privacy / Cookie).
 * Light theme, single-column centered, max-width 760px, generous padding.
 * Apply: <LegalLayout title="..." ...><LegalSection title="A. ...">...</LegalSection></LegalLayout>
 */
export const LegalLayout = ({ title, lastUpdate = "20 maggio 2026", children }) => {
  return (
    <article className="bg-galactico text-dodgers pt-36 pb-24 md:pt-44 md:pb-32 animate-fade-up">
      <div className="container-os">
        <div className="max-w-[760px] mx-auto">
          <span className="eyebrow">Legali</span>
          <h1
            className="font-display mt-6 leading-[1.05]"
            style={{ fontSize: "clamp(2rem, 4vw, 3rem)", letterSpacing: "-0.015em" }}
          >
            {title}
          </h1>
          <p className="mt-5 text-[14px] text-mandrogni">
            Ultimo aggiornamento: {lastUpdate}
          </p>
          <hr className="hr-os mt-10 mb-2 border-dodgers" />
          <div className="legal-body text-[16px] leading-[1.7] text-dodgers space-y-5 pt-6">
            {children}
          </div>
        </div>
      </div>
    </article>
  );
};

export const LegalSection = ({ title, children }) => (
  <section className="mt-12 first:mt-0">
    {title && (
      <h2 className="font-sans font-bold uppercase text-[20px] tracking-[0.04em] mb-4">
        {title}
      </h2>
    )}
    <div className="space-y-4">{children}</div>
  </section>
);

export default LegalLayout;
